import { portalApi } from "@services/api/portalApi";

export type WatchlistItem = {
    staffInitials: string;
    studentNumber: string;
    sortKey: string;
    attendance: {
        presentLength: number;
        totalLength: number;
    };
    punctuality: {
        punctualLength: number;
        totalLength: number;
    };
};

export type AddToWatchlistRequest = {
    studentNumber: string;
};

export type AddToWatchlistResponse = {
    studentNumber: string;
    sortKey: string;
};

export type ReorderWatchlistRequest = {
    studentNumber: string;
    beforeStudentNumber?: string | null;
    afterStudentNumber?: string | null;
};

export type ReorderWatchlistResponse = {
    studentNumber: string;
    sortKey: string;
};

/**
 * GET /watchlist/my
 */
export async function getMyWatchlist(): Promise<WatchlistItem[]> {
    try {
        const response = await portalApi.get("/me/watchlist");
        return response.data;
    } catch (error) {
        console.error("Error fetching watchlist:", error);
        throw error;
    }
}

/**
 * POST /watchlist/my
 * body: { studentNumber }
 */
export async function addStudentToMyWatchlist(
  studentNumber: string,
): Promise<AddToWatchlistResponse> {
    try {
        const response = await portalApi.post("/me/watchlist", { studentNumber } satisfies AddToWatchlistRequest);
        return response.data;
    } catch (error) {
        console.error("Error adding student to watchlist:", error);
        throw error;
    }
}

/**
 * DELETE /watchlist/my/:studentNumber
 */
export async function removeStudentFromMyWatchlist(
  studentNumber: string,
): Promise<void> {
    try {
        await portalApi.delete(`/me/watchlist/${encodeURIComponent(studentNumber)}`);
    } catch (error) {
        console.error("Error removing student from watchlist:", error);
        throw error;
    }
}

/**
 * POST /watchlist/my/reorder
 * body: { studentNumber, beforeStudentNumber, afterStudentNumber }
 */
export async function reorderMyWatchlistStudent(
  payload: ReorderWatchlistRequest,
): Promise<ReorderWatchlistResponse> {
    try {
        const response = await portalApi.post("/me/watchlist/reorder", payload);
        return response.data;
    } catch (error) {
        console.error("Error reordering watchlist:", error);
        throw error;
    }
}
